"use client";

import React from "react";
import { SearchResult, DocumentType } from "@/lib/types";
interface SearchResultsProps {
  results: SearchResult[];
}
export default function SearchResults({
  results
}: SearchResultsProps) {
  if (results.length === 0) {
    return null;
  }
  return <div className="w-full container mx-auto stack gap-12" data-sentry-component="SearchResults" data-sentry-source-file="SearchResults.tsx">
      <h2 className="text-4xl font-medium">Search Results</h2>

      <div className="stack gap-8">
        {results.map(result => <SearchResultCard key={result.id} result={result} />)}
      </div>
    </div>;
}
function SearchResultCard({
  result
}: {
  result: SearchResult;
}) {
  const {
    text,
    score,
    rawScore,
    matchCount,
    metadata,
    chunks
  } = result;
  const {
    documentType,
    title,
    url,
    pageNumber
  } = metadata;
  const [expanded, setExpanded] = React.useState(false);

  // Format the relevance score as a percentage
  const relevancePercent = Math.round(score * 100);
  const rawScorePercent = rawScore ? Math.round(rawScore * 100) : relevancePercent;

  // Clean any JSON-like content that might have made it to the display
  const cleanText = (input: string): string => {
    return input
    // Remove JSON-like patterns
    .replace(/\{["'][^}]*\}/g, "").replace(/\[["'][^\]]*\]/g, "").replace(/"[^"]+":\s*"[^"]+"/g, "").replace(/\\"[^\\"]+\\":\\"[^\\"]+\\"/g, "")
    // Clean up artifacts
    .replace(/,{2,}/g, "").replace(/\s+/g, " ").trim();
  };

  // Create a summary of the text if it's too long
  const cleanedText = cleanText(text);
  const maxPreviewLength = 300;
  const hasLongText = cleanedText.length > maxPreviewLength;
  const previewText = hasLongText && !expanded ? "" : cleanedText;

  // Get the number of chunks/sections in this document
  const numChunks = matchCount || chunks?.length || 1;
  return <div className="text-white border-b border-gray-300 pb-4" data-sentry-component="SearchResultCard" data-sentry-source-file="SearchResults.tsx">
      <div className="flex items-start justify-between mb-2 text-white">
        <div>
          {url && <a href={url} target="_blank" rel="noopener noreferrer" className="text-white hover:underline text-xl font-medium">
              {title}
            </a>}
          <div className="text-sm text-[#d1d1d1] flex items-center gap-2 flex-wrap">
            <span className="inline-flex items-center">
              {documentType === DocumentType.PDF ? <>
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                  Resource
                </> : <>
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                  Page
                </>}
            </span>
            {url && <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline truncate max-w-xs inline-block">
                {url}
              </a>}
            {/* {numChunks > 1 && (
              <span className="text-xs bg-gray-100 px-2 py-0.5 rounded-full">
                {numChunks} sections matched
              </span>
             )} */}
          </div>
        </div>
        {/* <div className="flex flex-col items-end gap-1">
          <span className="inline-flex items-center bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded-full w-max">
            {relevancePercent}% or {rawScorePercent}% Relevance
          </span>
          {numChunks > 1 && (
            <span className="inline-flex items-center bg-gray-100 text-gray-500 text-xs font-medium px-2 py-1 rounded-full">
              {numChunks} Matches
            </span>
          )}
         </div> */}
      </div>

      {/* <div className="text-gray-700 bg-gray-50 p-3 rounded">
        <div className="whitespace-pre-line">{previewText}</div>
         {hasLongText && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="bg-gray-400 text-gray-800 text-sm mt-1 hover:underline focus:outline-none block"
          >
            {expanded ? "Show less" : "Show Text"}
          </button>
        )}
       </div> */}
    </div>;
}